import type { MediaAssetPublic } from '@xingroute/schema'

// Split a route's media list into route-level (cover / intro) vs
// waypoint-bound buckets. Route-level = no waypoint_id field; waypoint-bound
// = waypoint_id present. Pure function, used by both RouteEditor and
// RouteDetailPage so a single GET /api/media?route_id=… powers both the
// cover/intro grid and the per-waypoint attachment popovers.

export interface GroupedMedia {
  routeLevel: MediaAssetPublic[]
  byWaypointId: Map<string, MediaAssetPublic[]>
}

export function groupMediaByWaypoint(items: readonly MediaAssetPublic[]): GroupedMedia {
  const routeLevel: MediaAssetPublic[] = []
  const byWaypointId = new Map<string, MediaAssetPublic[]>()
  for (const item of items) {
    if (item.waypoint_id === undefined) {
      routeLevel.push(item)
      continue
    }
    const bucket = byWaypointId.get(item.waypoint_id)
    if (bucket) bucket.push(item)
    else byWaypointId.set(item.waypoint_id, [item])
  }
  return { routeLevel, byWaypointId }
}
